function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Descriptions, Select, message, Divider, InputNumber, Tabs } from 'antd';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { Activity, EyeFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var TabPane = Tabs.TabPane;

var EditConsultation = function EditConsultation(_ref) {
  var check = _ref.check,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formLoading = _useState2[0],
      setFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isPatientUpdated = _useState8[0],
      setIsPatientUpdated = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      bilanOptions = _useState12[0],
      setBilanOptions = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      serviceTree = _useState14[0],
      setServiceTree = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      medicalExamId = _useState16[0],
      setMedicalExamId = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _Form$useForm3 = Form.useForm(),
      _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
      mcForm = _Form$useForm4[0];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setFormLoading(true);
    var formData = new FormData();
    formData.append("id", check.id);
    formData.append("reason", values.reason);
    formData.append("traitement_anterieur", values.traitement_anterieur);
    formData.append('weight', values.weight);
    formData.append('ta', values.ta);
    formData.append("pulse", values.pulse);
    formData.append("temperature", values.temperature);
    formData.append("spO2", values.spO2);
    formData.append("glycemy", values.glycemy);
    formData.append("tt", values.tt);
    formData.append("ant_medicals", values.ant_medicals);
    formData.append("ant_chirugicals", values.ant_chirugicals);
    formData.append("ant_gyn", values.ant_gyn);
    formData.append("ant_family", values.ant_family);
    formData.append("customer_id", check.customer.id);
    formData.append("uid", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editmedicalcheckintro', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  var onMcFinish = function onMcFinish(values) {
    setFormLoading(true);
    setErrorMessage("");
    var formData = new FormData();
    formData.append("exam_general", values.exam_general);
    formData.append("exam_neuro", values.exam_neuro);
    formData.append("exam_pleuro", values.exam_pleuro);
    formData.append("exam_cardio", values.exam_cardio);
    formData.append("exam_rhuma", values.exam_rhuma);
    formData.append("exam_cutaneo", values.exam_cutaneo);
    formData.append("exam_other", values.exam_other);
    formData.append("resum_syndrome", values.resum_syndrome);
    formData.append("hypo_diagnostic", values.hypo_diagnostic);
    formData.append("final_diagnostic", values.final_diagnostic);
    formData.append("treatments", values.treatments);
    formData.append("recommandations", values.recommandations);
    formData.append("uid", Common.currentUser.id);
    formData.append("id", check.id);
    formData.append("customer_id", check.customer.id);
    axios.post(Common.baseApiUrl + 'editmedicalcheckdetails', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(false);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      reason: check.reason == "null" ? "" : check.reason,
      traitement_anterieur: check.traitement_anterieur == "null" ? "" : check.traitement_anterieur,
      weight: check.weight == "null" ? "" : check.weight,
      ta: check.ta == "null" ? "" : check.ta,
      tt: check.tt == "null" ? "" : check.tt,
      spO2: check.spO2 == "null" ? "" : check.spO2,
      pulse: check.pulse == "null" ? "" : check.pulse,
      temperature: check.temperature == "null" ? "" : check.temperature,
      glycemy: check.glycemy == "null" ? "" : check.glycemy,
      ant_gyn: check.ant_gyn == "null" ? "" : check.ant_gyn,
      ant_chirugicals: check.ant_chirugicals == "null" ? "" : check.ant_chirugicals,
      ant_family: check.ant_family == "null" ? "" : check.ant_family,
      ant_medicals: check.ant_medicals == "null" ? "" : check.ant_medicals
    });
    mcForm.setFieldsValue({
      exam_general: check.exam_general == "null" ? "" : check.exam_general,
      exam_neuro: check.exam_neuro == "null" ? "" : check.exam_neuro,
      exam_pleuro: check.exam_pleuro == "null" ? "" : check.exam_pleuro,
      exam_cardio: check.exam_cardio == "null" ? "" : check.exam_cardio,
      exam_rhuma: check.exam_rhuma == "null" ? "" : check.exam_rhuma,
      exam_cutaneo: check.exam_cutaneo == "null" ? "" : check.exam_cutaneo,
      exam_other: check.exam_other == "null" ? "" : check.exam_other,
      resum_syndrome: check.resum_syndrome == "null" ? "" : check.resum_syndrome,
      hypo_diagnostic: check.hypo_diagnostic == "null" ? "" : check.hypo_diagnostic,
      final_diagnostic: check.final_diagnostic == "null" ? "" : check.final_diagnostic,
      treatments: check.treatments == "null" ? "" : check.treatments,
      recommandations: check.recommandations == "null" ? "" : check.recommandations
    });
  }, [isPatientUpdated, check]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: check != null ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            children: /*#__PURE__*/_jsxs(Tabs, {
              animated: true,
              defaultActiveKey: 1,
              children: [/*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EyeFill, {
                    size: 30
                  }), " CONSULTATION"]
                }),
                children: /*#__PURE__*/_jsxs(Form, {
                  form: mcForm,
                  layout: "vertical",
                  onFinish: onMcFinish,
                  children: [/*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "EXAMENS / EXAMENES"
                    }), /*#__PURE__*/_jsx(Container, {
                      children: /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen g\xE9n\xE9ral / Examen general",
                            name: "exam_general",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen neurologique / Examen neurol\xF3gico",
                            name: "exam_neuro",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen cardiovasculaire / examen cardiovascular",
                            name: "exam_cardio",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen rhumatologique / Examen reumatol\xF3gico",
                            name: "exam_rhuma",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen pleuropulmonaire / Examen pleuropulmonar",
                            name: "exam_pleuro",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen cutan\xE9o-phan\xE9rien / Examen de la piel y el fan\xE9rico",
                            name: "exam_cutaneo",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen ailleurs / Revisar en otro lugar",
                            name: "exam_other",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        })]
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "R\xE9sum\xE9 Syndromique / Resumen sindr\xF3mico"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "resum_syndrome",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "Hypoth\xE8ses diagnostiques / Hip\xF3tesis diagn\xF3sticas"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "hypo_diagnostic",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("length", {
                      children: "CONCLUSION / CONCLUSI\xD3N"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Diagnostic retenu / Diagn\xF3stico retenido",
                      name: "final_diagnostic",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Traitements / Tratos",
                      name: "treatments",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Recommandations / Recomendaciones",
                      name: "recommandations",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: errorMessage,
                      type: "error",
                      banner: true
                    })
                  }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: successMessage,
                      type: "success",
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  })]
                })
              }, 1), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Activity, {
                    size: 30
                  }), "PLAINTE ET CONSTANTES"]
                }),
                children: /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  layout: "vertical",
                  onFinish: onFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "reason",
                    label: "Motif / Motivo de la visita",
                    rules: [{
                      required: true,
                      message: "Ce champ est obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(Input, {})
                  }), /*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "traitement_anterieur",
                        label: "Histoire de la maladie / Historia de la enfermedad",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CONSTANTES / CONSTANTES"
                      })
                    }), /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "ta",
                          label: "TA / Presi\xF3n arterial",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "mmHg"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "pulse",
                          label: "Pouls / Legumbres",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "Pouls/Min"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "temperature",
                          label: "Temperature / Temperatura",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "\xB0C"
                          })
                        })
                      })]
                    }), /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "spO2",
                          label: "SpO2 / saturaci\xF3n de ox\xEDgeno en sangre",
                          children: /*#__PURE__*/_jsx(Input, {})
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "glycemy",
                          label: "Glycemie / Glucemia",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "g/L"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "weight",
                          label: "Poids / Peso",
                          children: /*#__PURE__*/_jsx(InputNumber, {
                            addonAfter: "Kg"
                          })
                        })
                      })]
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "tt",
                      label: "TT / tratamiento",
                      children: /*#__PURE__*/_jsx(Input, {})
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "ANTECEDANTS / HISTORIA"
                      })
                    }), /*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "PERSONNELS / PERSONAL"
                      })
                    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_medicals",
                      label: "Medicaux / M\xE9dico",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_chirugicals",
                      label: "Chirugicaux / Quir\xFArgico",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_gyn",
                      label: "Gyn\xE9co-obstetrique / Ginecolog\xEDa-obstetricia",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "FAMILIAUX / FAMILIAS"
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_family",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: errorMessage,
                      type: "error",
                      banner: true
                    })
                  }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: successMessage,
                      type: "success",
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  })]
                })
              }, 2)]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 5,
            md: 5,
            children: [/*#__PURE__*/_jsxs(Descriptions, {
              labelStyle: {
                background: '#FCD013'
              },
              contentStyle: {
                background: '#FCD013'
              },
              column: 1,
              bordered: true,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Nom",
                children: check.customer.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Pr\xE9nom",
                children: check.customer.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Profession",
                children: check.customer.job
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          })]
        })
      })
    }) : /*#__PURE__*/_jsx("p", {
      children: "Une erreur est survenue"
    })
  });
};

export default EditConsultation;